import React from 'react';
import {
    Box,
    Dialog,
    DialogContent,
    IconButton,
    Stack,
    Tooltip,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { useSelector } from 'react-redux';
import CloseIcon from "@mui/icons-material/Close";
import { Form, FormikProvider, useFormik } from 'formik';
import DialogActions from '@mui/material/DialogActions';
import { LoadingButton } from '@mui/lab';
import { toast } from 'react-toastify';

import { RootState } from '../../store';
import FormBuilder from '../form-builder';
import { SET_PHONE_INPUTS } from '../../builders/admins-builders';
import { AuthService } from '../../services/auth.service';

interface Props {
    visible: boolean,
    onClose(): void,
};

export const SetPhoneForm: React.FC<Props> = ({
    visible,
    onClose,
}) => {
    const { authUser } = useSelector((state: RootState) => state.auth);
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));

    const formik = useFormik({
        initialValues: {
            phone: authUser?.phone,
        },
        onSubmit: async (values) => {
            await AuthService.changePhone(values.phone, (isValid, msg) => {
                if (!isValid) {
                    toast(
                        msg, 
                        {
                            autoClose: 1500,
                            type: 'error',
                        }
                    );
                    return;
                }

                formik.resetForm();

                toast(
                    msg, 
                    {
                        autoClose: 1500,
                        type: 'success',
                    }
                );

                onClose();
            });
        },
    });

    const { handleSubmit, errors, touched, isSubmitting, getFieldProps } = formik;

    return (
        <Dialog
            open={visible}
            maxWidth={'lg'}
            scroll={'paper'}
            fullWidth={isSmallScreen}
        >
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Stack direction={'row'} justifyContent={'space-between'}>
                    <Typography sx={{ ml: 3, mb: 2, mt: 2 }} fontSize={18} fontWeight={500} color={'text.default'}>
                        Change Phone Number
                    </Typography>
                    <Tooltip title="Close form">
                        <IconButton
                            onClick={onClose}
                            component="span"
                            sx={{ mr: 2, height: 30, width: 30, alignSelf: 'center' }}
                        >
                            <CloseIcon />
                        </IconButton>
                    </Tooltip>
                </Stack>
            </Box>
            <FormikProvider value={formik}>
                <Form noValidate onSubmit={handleSubmit}>
                    <DialogContent sx={{ maxWidth: 800, minWidth: 500 }} dividers>
                        <FormBuilder
                            size="medium"
                            errors={errors}
                            getFieldProps={getFieldProps}
                            touched={touched}
                            inputs={[...SET_PHONE_INPUTS]}
                        />
                    </DialogContent>
                    <DialogActions sx={{ mt: -3 }}>
                        <LoadingButton
                            variant="contained"
                            type="submit"
                            loading={isSubmitting}
                            fullWidth={isSmallScreen}
                        >
                            Submit
                        </LoadingButton>
                    </DialogActions>
                </Form>
            </FormikProvider>
        </Dialog>
    )
}